import { ethers } from "ethers";

const state = () => ({
    cropsContract: null,
    PRODUCE_OFFSET: 1000,
});

const mutations = {
    initializeContract(state, contract) {
        state.cropsContract = contract;
    },
};

const actions = {
    boot({ commit, rootState }, { contractAddress }) {
        const abi = require("@/plugins/artefacts/crops.json");

        const { signer, defaultSigner } = rootState.site;
        const contract = new ethers.Contract(
            contractAddress,
            abi,
            signer || defaultSigner
        );

        commit("initializeContract", contract);
    },

    async getSeedsBalance({ state, rootState }) {
        const contract = state.cropsContract;
        const cropTypes = rootState.content.cropTypes;
        const account = rootState.user.storedAccount;

        const accounts = new Array(cropTypes.length).fill(account);
        const seedIds = [];
        for (let i = 1; i <= cropTypes.length; i++) {
            seedIds.push(i);
        }

        const seedBalances = await contract.balanceOfBatch(accounts, seedIds);

        const seeds = seedBalances.map((balance, index) => {
            return {
                tokenId: index,
                balance: parseFloat(balance),
            };
        });

        return seeds;
    },
};

const getters = {};

export default {
    state,
    mutations,
    getters,
    actions,
    namespaced: true,
};
